(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/step-indicator/assets/javascripts/step-indicator-result.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/step-indicator/assets/javascripts/step-indicator-result.js');
"use strict";


const {
  Shield
} = svs.components.lbUi.shield;
const {
  breakpoints,
  useMediaQuery,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const {
  useCompetitionType,
  useCompetitionBranding
} = svs.components.marketplaceCompetition.services.hooks;
const StepIndicatorResult = _ref => {
  let {
    drawResults,
    labels,
    isTeamDetails,
    hasUnits
  } = _ref;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const competitionId = useCompetitionId();
  const compType = useCompetitionType(competitionId);
  const competitionBranding = useCompetitionBranding(compType);
  let sizeClass;
  let hasShadow = true;
  if (isTeamDetails) {
    sizeClass = isSmall ? 'shield-small' : 'shield-almost-medium';
    hasShadow = false;
  } else {
    sizeClass = isSmall ? 'shield-almost-medium' : 'shield-medium';
  }
  const getBrandingClass = result => {
    if (result.hasPlayed && result.isContributing) {
      if (result.hasHighestScore) {
        return "shield-".concat(competitionBranding, "-gold");
      }
    } else {
      return "shield-".concat(competitionBranding, "-disabled");
    }
  };
  const _renderResult = (result, index) => {
    const {
      drawNumber,
      hasPlayed,
      correctCount
    } = result;
    const label = Array.isArray(labels) ? labels[index] : null;
    const brandingClass = getBrandingClass(result);
    return React.createElement("div", {
      className: "competition-step-indicator-item",
      key: drawNumber
    }, React.createElement(Shield, {
      branding: competitionBranding,
      className: [sizeClass, brandingClass].filter(Boolean).join(' '),
      options: {
        hasShadow,
        hasHover: true
      }
    }, React.createElement("span", {
      className: "shield-value"
    }, hasPlayed ? correctCount : '-'), Boolean(hasPlayed && hasUnits) && React.createElement("span", {
      className: "shield-unit"
    }, "r\xE4tt")), Boolean(label) && React.createElement("div", {
      className: "step-indicator-label"
    }, label));
  };
  return React.createElement("div", {
    className: isTeamDetails ? 'competition-step-indicator-result-team' : 'competition-step-indicator-result-player'
  }, drawResults.map(_renderResult));
};
setGlobal('svs.components.marketplaceShared.stepIndicator.StepIndicatorResult', StepIndicatorResult);

 })(window);